import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ActiveButton, InactiveButton } from './FilterButtons';

const getParentTreePath = (treePath = '') => {
  const parts = treePath.split('|');
  parts.pop();
  return parts.join('|');
};

function NodeView({ node, onChange, value }) {
  const { children = {} } = node;
  const treePath = node.treePath;
  const isActiveFilter = _.startsWith(value, treePath);

  const childrenAreVisible = _.includes(value, treePath);

  const parentTreePath = getParentTreePath(treePath);

  // TODO this can not be used as long as we have articles on other levels than on leaves (the deepest possible node)
  const getDeepestPossibleNode = node => {
    if (!node.children) {
      return node;
    }
    const keys = Object.keys(node.children);

    if (keys.length === 1) {
      return getDeepestPossibleNode(node.children[keys[0]]);
    }
    return node;
  };

  return (
    <>
      <div style={{ cursor: 'pointer' }}>
        {node.name && isActiveFilter && (
          <ActiveButton
            value={node.name}
            onClick={() => onChange(parentTreePath)}
          />
        )}
        {node.name && !isActiveFilter && (
          <InactiveButton
            value={node.name}
            count={node.count}
            onClick={() => onChange(node.treePath)}
          />
        )}
      </div>
      {childrenAreVisible &&
        _.chain(children)
          .sortBy(x => x.name)
          .map(child => (
            <NodeView
              key={child.name}
              onChange={onChange}
              node={child}
              value={value}
            />
          ))
          .value()}
    </>
  );
}

NodeView.propTypes = {
  node: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

function TreeFilterFacet({ tree, querySpecification, onChange, name }) {
  const value = _.get(querySpecification, `${name}.or[0].eq`, '');

  const handleOnChange = newValue => {
    if (newValue) {
      onChange(name, { or: [{ eq: newValue }, { iLike: `${newValue}|%` }] });
    } else {
      onChange(name, { iLike: `%` });
    }
  };

  return (
    <div className="ps-2">
      {_.chain(tree)
        .sortBy(x => x.name)
        .map(node => (
          <NodeView
            key={node.name}
            node={node}
            className="sidebar-icon-menu-link fw-bold me-2"
            onChange={handleOnChange}
            {...{
              name,
              value,
              querySpecification,
            }}
          />
        ))
        .value()}
    </div>
  );
}

TreeFilterFacet.propTypes = {
  tree: PropTypes.object.isRequired,
  querySpecification: PropTypes.object,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

TreeFilterFacet.defaultProps = {
  querySpecification: {},
};

export default TreeFilterFacet;
